import PropTypes from 'prop-types';
var propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.string,
  disabled: PropTypes.bool,
  disableLabelShrinking: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.node,
  helperTextState: PropTypes.oneOf(['default', 'error', 'success']),
  helperTextVisibility: PropTypes.oneOf(['auto', 'hidden', 'visible']),
  id: PropTypes.string,
  label: PropTypes.node,
  maxLength: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  separateLabel: PropTypes.bool,
  trailingIcon: PropTypes.node,
  type: PropTypes.oneOf(['date', 'datetime-local', 'email', 'file', 'month', 'number', 'password', 'search', 'text', 'url', 'week']),
  value: PropTypes.string
};
export default propTypes;